import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import combineRoutes from './combine';

import PublicLayout from '../components/PublicLayout';
import ProtectedLayout from '../components/ProtectedLayout';
import AuthLayout from '../components/AuthLayout';
import NotFound from '../pages/NotFound';

// routes
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AuthLayout />} errorElement={<NotFound />}>
      <Route element={<PublicLayout />}>
        {/* <Route path='/' element={<LoginPage />} /> */}

        {combineRoutes.public.map((route) => (
          <Route
            key={route.name}
            exact
            path={route.path}
            element={React.createElement(route.component)}
          />
        ))}
      </Route>

      <Route element={<ProtectedLayout />}>
        {combineRoutes.auth.map((route) => (
          <Route
            key={route.name}
            exact
            path={route.path}
            element={React.createElement(route.component)}
          />
        ))}
      </Route>
    </Route>,
  ),
);

export default router;
